import formatExampleModalHtml from "./format-example-modal-html.html";

export class FormatExampleModal {

    constructor() {
        $("body").append(formatExampleModalHtml);
        this.modal = $("#formatExampleDialog");
    }

    init() {
        var self = this;
        $(".format-example-button").click(function () {
            var entityType = $(this).attr("entity-type");
            var propertyType = $(this).attr("property-type");
            $(".example-format-dialog-property-type").each(function () {
                $(this).text(propertyType);
            });
            $(".example-format-dialog-entity-type").each(function () {
                $(this).text(entityType);
            });
            self.modal.modal("show");
        });
        $(".format-example-modal-close-button").click(function () {
            self.modal.modal("hide");
        });
    }

    close() {
        var self = this;
        self.modal.modal("hide");
    }
}